// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1876) return "static/chunks/1876-ff74794fe7f5290d.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2937 ? "eabe11fc" : chunkId) + "." + {"1167":"0b3a37b4ca98e967","2937":"8549aaeb3e4e6c78","9894":"c8d1ddb46720ac38"}[chunkId] + ".js";
};